import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import NavigationEntity from '../../../types/NavigationEntity';

class NavigationEntityTextItem extends Component {
  render() {
    const { className, entity, ...rest } = this.props;
    const { active, label } = entity;

    if (!entity) {
      return null;
    }

    // nav-item class is used for now to match Bootstrap class names.
    // Should be changed in the future.
    return (
      <span
        className={classNames('nav-text', className, {
          active
        })}
        {...rest}
      >
        {label}
      </span>
    );
  }
}

NavigationEntityTextItem.propTypes = {
  entity: NavigationEntity.isRequired,
  className: PropTypes.string
};

export default NavigationEntityTextItem;



// WEBPACK FOOTER //
// ./src/components/navigation/NavigationEntityTextItem/index.jsx